import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CmsProvider } from "@/contexts/CmsContext";
import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Academics from "@/pages/Academics";
import Hospital from "@/pages/Hospital";
import Admissions from "@/pages/Admissions";
import CampusLife from "@/pages/CampusLife";
import Faculty from "@/pages/Faculty";
import NMCDisclosures from "@/pages/NMCDisclosures";
import TeachingStaff from "@/pages/TeachingStaff";
import Careers from "@/pages/Careers";
import NewsDetail from "@/pages/NewsDetail";
import Contact from "@/pages/Contact";
import News from "@/pages/News";
import Gallery from "@/pages/Gallery";
import Admin from "@/pages/Admin";
import AdminCMS from "@/pages/AdminCMS";

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <ScrollToTop />
        <CmsProvider>
          <Routes>
            {/* Admin routes without Layout */}
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/cms/*" element={<AdminCMS />} />
            
            {/* Public routes with Layout */}
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/about" element={<Layout><About /></Layout>} />
            <Route path="/academics" element={<Layout><Academics /></Layout>} />
            <Route path="/hospital" element={<Layout><Hospital /></Layout>} />
            <Route path="/admissions" element={<Layout><Admissions /></Layout>} />
            <Route path="/campus-life" element={<Layout><CampusLife /></Layout>} />
            <Route path="/faculty" element={<Layout><Faculty /></Layout>} />
            <Route path="/nmc-disclosures" element={<Layout><NMCDisclosures /></Layout>} />
            <Route path="/teaching-staff" element={<Layout><TeachingStaff /></Layout>} />
            <Route path="/careers" element={<Layout><Careers /></Layout>} />
            <Route path="/contact" element={<Layout><Contact /></Layout>} />
            <Route path="/news" element={<Layout><News /></Layout>} />
            <Route path="/news/:id" element={<Layout><NewsDetail /></Layout>} />
            <Route path="/gallery" element={<Layout><Gallery /></Layout>} />
          </Routes>
        </CmsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
